export default [
  {
    path: '/baibu-bill',
    name: 'BaibuBill',
    component: () => import('@/layout'),
    redirect: '/baibu-bill/quota-list',
    meta: {
      title: '百布账期管理',
    },
    children: [
      {
        path: 'quota-list',
        name: 'BaibuBillQuotaList',
        component: () => import('@/views/web/baibu-bill/quota-list/list'),
        meta: {
          title: '城市额度管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-26',
          trackName: '百布账期管理 - 城市额度管理',
          activeMenu: '/baibu-bill/quota-list',
        },
      },
      {
        path: 'credit-list',
        name: 'BaibuBillCreditList',
        component: () => import('@/views/web/baibu-bill/credit-list/list'),
        meta: {
          title: '客户授信管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-27',
          trackName: '百布账期管理 - 客户授信管理',
          activeMenu: '/baibu-bill/credit-list',
        },
      },
      {
        path: 'disburse-list',
        name: 'BaibuBillDisburseList',
        component: () => import('@/views/web/baibu-bill/disburse-list/list'),
        meta: {
          title: '城市支用查询',
          noCache: false,
          auth: true,
          trackCode: 'menu-28',
          trackName: '百布账期管理 - 城市支用查询',
          activeMenu: '/baibu-bill/disburse-list',
        },
      },
      {
        path: 'bill-list',
        name: 'BaibuBillBillList',
        component: () => import('@/views/web/baibu-bill/bill-list/list'),
        meta: {
          title: '客户账单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-29',
          trackName: '百布账期管理 - 客户账单管理',
          activeMenu: '/baibu-bill/bill-list',
        },
      },
    ],
  },
];

